import type { VariantKey } from "./types";

export const ImageType = {
  Default: "default",
  MainImage: "mainImage",
} as const;

export const DefaultCarousel = { imageType: ImageType.Default } as const;

export const VARIANT_SPECS: Record<VariantKey, { aspectRatio: string; width: number }> = {
  landscape250x99: { aspectRatio: "250/99", width: 2000 },
  size80x80: { aspectRatio: "1/1", width: 80 },
  size118x118: { aspectRatio: "1/1", width: 118 },
  size320x180: { aspectRatio: "4/3", width: 320 },
  size320x240: { aspectRatio: "4/3", width: 320 },
  size500x500: { aspectRatio: "1/1", width: 500 },
  size540x360: { aspectRatio: "3/2", width: 540 },
  size640x360: { aspectRatio: "16/9", width: 640 },
  size660w: { aspectRatio: "260/183", width: 660 },
  size768x768: { aspectRatio: "1/1", width: 768 },
  size800x1200: { aspectRatio: "2/3", width: 800 },
  size1200x800: { aspectRatio: "3/2", width: 1200 },
  size1200x1200: { aspectRatio: "1/1", width: 1200 },
  size1280x720: { aspectRatio: "16/9", width: 1280 },
  size1676x943: { aspectRatio: "16/9", width: 1676 },
};
